module.exports = __webpack_public_path__ + "img/wallimage2.374d4f2d.jpg";